export default __webpack_public_path__ + "static/media/Kitego.c2eb8e02.png";